import { get } from "./WebService";

export async function getEnums() {
    const { list } = await get("/enums/list-enums");
    if (list && list.length > 0) {
        return list[0];
    }
    return null;
}

export const menus = {
    c002: {
        menu: "Ferramentas",
        category: "tools",
        path: "/customer/customerConsult.zul",
        description: "customers",
        name: "Empresas"
    },
    c003: {
        menu: "Ferramentas",
        category: "tools",
        path: "/userGroup/userGroupConsult.zul",
        description: "profile",
        name: 'Perfis'
    },
    c004: {
        menu: "Ferramentas",
        category: "tools",
        path: "/user/userConsult.zul",
        description: "user",
        name: "Usuários"
    },
    c005: {
        menu: "Ferramentas",
        category: "tools",
        path: "/tools/certificateConsult.zul",
        description: "certificate",
        name: "Certificados MNI"
    },
    c006: {
        menu: "Ferramentas",
        category: "tools",
        path: "/tools/credentials.zul",
        description: "credentials",
        name: "Credenciais de Robô"
    },
    c008: {
        menu: "Meu Perfil",
        category: "myprofile",
        path: "/user/userChangePassword.zul",
        description: "userChangePassword",
        name: "Alterar Senha"
    },
    c014: {
        menu: "Prestação de Contas",
        category: "labor",
        path: "/labor/LaborConsult.zul",
        description: "providingAccount",
        name: 'PC Labor'
    },
    c025: {
        menu: "Consulta Jurídica",
        category: "processes",
        path: "/processes/LawyersConsult.zul",
        description: "lawyers",
        name: "Consulta Advogados"
    },
    c026: {
        menu: "Consulta Jurídica",
        category: "processes",
        path: "/processes/ProcessesConsult.zul",
        description: "process",
        name: "Consulta Processos"
    },
    c027: {
        menu: "Consulta Jurídica",
        category: "processes",
        path: "/processes/CompanyConsult.zul",
        description: "company",
        name: "Consulta Empresas"
    },
    c015: {
        menu: "Cobrança",
        category: "umc",
        path: "/umd/TCD.zul",
        description: "tcd",
        name: "TCD"
    },
    //colocar o collapse
    c028: {
        menu: "Cadastro Geral",
        category: "legal",
        path: "/umd/TCD.zul",
        description: "areaType",
        name: "Áreas"
    },

    c031: {
        menu: "Ferramentas",
        category: "tools",
        path: "/umd/TCD.zul",
        description: "team",
        name: "Equipes"
    },
    c032: {
        menu: "Cadastro Geral",
        category: "legal",
        path: "/umd/TCD.zul",
        description: "justice",
        name: "Justiças"
    },
    c033: {
        menu: "Cadastro Geral",
        category: "legal",
        path: "/umd/TCD.zul",
        description: "actionType",
        name: "Ações"
    },
    c029: {
        menu: "Cadastro Geral",
        category: "legal",
        path: "/umd/TCD.zul",
        description: "complementVara",
        name: "Complementos - Varas"
    },
    c034: {
        menu: "Cadastro Geral",
        category: "legal",
        path: "/umd/TCD.zul",
        description: "complement",
        name: "Complementos"
    },
    c035: {
        menu: "Cadastro Geral",
        category: "legal",
        path: "/umd/TCD.zul",
        description: "organ",
        name: "Orgãos"
    },
    c036: {
        menu: "Cadastro Geral",
        category: "legal",
        path: "/umd/TCD.zul",
        description: "processFase",
        name: "Fase Processo"
    },
    c048: {
        menu: "Cadastro Geral",
        category: "legal",
        path: "/umd/TCD.zul",
        description: "fasePenhora",
        name: "Fase Penhora"
    },
    c049: {
        menu: "Cadastro Geral",
        category: "legal",
        path: "/umd/TCD.zul",
        description: "tipoBemPenhora",
        name: "Tipo Bem Penhora"
    },
    c037: {
        menu: "Cadastro Geral",
        category: "legal",
        path: "/umd/TCD.zul",
        description: "risk",
        name: "Riscos"
    },

    c040: {
        menu: "Cadastro Geral",
        category: "legal",
        path: "/umd/TCD.zul",
        description: "indice",
        name: "Índices"
    },
    c042: {
        menu: "Cadastro Geral",
        category: "legal",
        path: "/umd/TCD.zul",
        description: "forum",
        name: "Fóruns"
    },
    c043: {
        menu: "Ferramentas",
        category: "legal",
        path: "/umd/TCD.zul",
        description: "cliente",
        name: "Clientes"
    },
    c039: {
        menu: "Gestão de Demandas",
        category: "legalConsult",
        path: "/umd/TCD.zul",
        description: "processos",
        name: "Processos"
    },
    c044: {
        menu: "Gestão de Demandas",
        category: "legalConsult",
        path: "/umd/TCD.zul",
        description: "casos",
        name: "Casos"
    },
    c045: {
        menu: "Gestão de Demandas",
        category: "legalConsult",
        path: "/umd/TCD.zul",
        description: "solicitacoes",
        name: "Solicitações"
    },
    c047: {
        menu: "Gestão de Demandas",
        category: "legalConsult",
        path: "/umd/TCD.zul",
        description: "batchRescheduling",
        name: "Reagendamento em Lote"
    },
    c016: {
        menu: "Robôs",
        category: "robo",
        path: "/robo/TCD.zul",
        description: "logroboedital",
        name: "Log Robô Edital"
    },
    c017: {
        menu: "Robôs",
        category: "robo",
        path: "/robo/TCD.zul",
        description: "logroboemails",
        name: "Log Robô Emails Push"
    },
    c050: {
        menu: "Cobrança",
        category: "umc",
        path: "",
        description: "baseDeDados",
        name: "Base de Dados"
    },
    c053: {
        menu: "Cadastro Geral",
        category: "cadastro_cobranca",
        path: "",
        description: "gruposUsuarios",
        name: "Grupos"
    },
    c060: {
        menu: "Ferramentas",
        category: "tools",
        path: "/tools/campanhas",
        description: "campanhas",
        name: "Campanhas"
    },
    c061: {
        menu: "Robôs",
        category: "robo",
        path: "/tcd/import-movimentation",
        description: "importarRecortes",
        name: "Importar Recortes"
    },
    c051: {
        menu: "Cadastro Geral",
        category: "cadastro_cobranca",
        path: "",
        description: "tipoOcorrencia",
        name: "Tipos de Ocorrência"
    },
    c052: {
        menu: "Cadastro Geral",
        category: "cadastro_cobranca",
        path: "",
        description: "statusFicha",
        name: "Status"
    },
    c054: {
        menu: "Ferramentas",
        category: "tools",
        path: "/tools/recordings.zul",
        description: "recordings",
        name: "Gravações"
    },
    c055: {
        menu: "Ferramentas",
        category: "tools",
        path: "/umc/remessa.zul",
        description: "remessaImport",
        name: "Importação de Remessa"
    },
    c056: {
        menu: "Ferramentas",
        category: "tools",
        path: "/tools/baixa-pagamento",
        description: "baixaPagamento",
        name: "Baixa de Pagamento"
    },
    c057: {
        menu: "Monitoria",
        category: "coordenador",
        path: "/coordenador/monitoria",
        description: "monitoria",
        name: "Monitoria"
    },
    c058: {
        menu: "Relatórios",
        category: "umc",
        path: "/cobranca/relatorios",
        description: "relatorios",
        name: "Relatórios Dinâmicos"
    },
    c059: {
        menu: "Cadastro Geral",
        category: "cadastro_cobranca",
        path: "",
        description: "marcacaoEspecial",
        name: "Marcações Especiais"
    },
    c062: {
        menu: "Ferramentas",
        category: "tools",
        path: "/tools/contas-bancarias",
        description: "contasBancarias",
        name: "Contas Bancárias"
    },
    c064: {
        menu: "Cobrança",
        category: "umc",
        path: "/pages/cobranca/regras-fila",
        description: "regrasFila",
        name: "Regras da Fila"
    },
    c065: {
        menu: "Cobrança",
        category: "umc",
        path: "/pages/cobranca/processar-fila",
        description: "processarFila",
        name: "Processar Fila"
    },
    c066: {
        menu: "Cobrança",
        category: "umc",
        path: "/pages/cobranca/fila-de-trabalho",
        description: "filaTrabalho",
        name: "Fila de Trabalho"
    },
    c067: {
        menu: "Cobrança",
        category: "umc",
        path: "/pages/cobranca/fila-solicitacoes",
        description: "filaSolicitacoes",
        name: "Fila de Solicitações"
    }
}

export const trueOrFalseEnum = [
    {
        id: 1,
        name: "Ambos",
        value: null
    },
    {
        id: 2,
        name: "Sim",
        value: true
    },
    {
        id: 3,
        name: "Não",
        value: false
    },
]



export const situacao = [
    {
        code: "A",
        name: "Ativo"
    },
    {
        code: "I",
        name: "Inativo"
    },
];